<template>
  <div>
    <Modal
      v-model="visiblePreview"
      footer-hide
      width="800"
    >
      <p
        slot="header"
        class="text-center"
      >查看工人反馈素材</p>
      <div>
        <!-- <Row class="m-b-5">
          <i-col class="text-right">
            <Button
              size="small"
              type="success"
              @click="viewBigImage"
            >查看原图</Button>
          </i-col>
        </Row> -->
        <img-light-box
          ref="imgLightBox"
          :showModal="visiblePreview"
          :sortIndex="0"
        ></img-light-box>
      </div>
    </Modal>
  </div>
</template>

<script>
import ImgLightBox from '@/components/common/ImgVideoLightBox'
import { getWorkdayTaskAttach } from '@/api/msp/apptask'
export default {
  components: { ImgLightBox },
  data () {
    return {
      visiblePreview: false,
      fileName: '',
      workdayId: null,
      fileList: []
    }
  },
  methods: {
    showModal (id) {
      if (!id) {
        this.$Notice.error({ desc: '非法访问，缺少必要参数' })
        return false
      }
      this.workdayId = id
      this.getTaskAttachFiles()
      // this.info = data
      // const postData = {
      //   startIndex: 0,
      //   imgList: this.info.taskitemFileList
      // }
      // this.fileName = `${this.info.stationName} ${this.info.code}`
      // this.$refs.imgLightBox.init(postData)
      this.visiblePreview = true
    },
    getTaskAttachFiles () {
      this.fileList = []
      getWorkdayTaskAttach({ workdayId: this.workdayId }).then(res => {
        if (res && !res.errcode) {
          if (res.length) {
            res.forEach(item => {
              this.fileList.push({
                mimeType: 'image/jpeg',
                fileKey: item,
                filePath: item
              })
            })
          }

          const postData = {
            startIndex: 0,
            imgList: this.fileList
          }
          this.$nextTick(() => {
            this.$refs.imgLightBox.init(postData)
          })
        }
      })
    }
  }
}
</script>
